{
  "version": 1,
  "asset_id": "e92d1a37-8655-4308-8ffd-0fb815690cc5",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/e92d1a37-8655-4308-8ffd-0fb815690cc5/southend-drone-poster-640.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/e92d1a37-8655-4308-8ffd-0fb815690cc5/southend-drone-poster-640.webp",
  "original_filename": "southend-drone-poster-640.webp",
  "size": 49156,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:52:15Z"
}
